import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { getData } from "src/utils/axios/serverHelper";
import { formatDate } from "src/utils/string/stringUtil";
import { EQM1010_R01Filter } from "./Store_EQM1010_R01";
import { EQM1010_R01Dto } from "./Dto_EQM1010_R01";

const baseUrl = `${config.apiUrl}/EQM1010_R01`;


// ... existing code ...
export const getEQM1010_R01List = async (option: string, filter: Partial<EQM1010_R01Filter>, listLength: number = 0) => {
    const url = `${baseUrl}/${option}`;
    
    const formattedDate = filter.baseDate ? formatDate(filter.baseDate) : undefined;
    
    const params = {
        compCd: filter.compCd || undefined,
        date: formattedDate,
        plcaddressid: filter.plcaddressid ?? undefined,
        listLength: listLength
    };
    return await getData<ResponseDto<EQM1010_R01Dto[]>>(url, { params });
}

export const exportEQM1010_R01Excel = async (option: string, filter: Partial<EQM1010_R01Filter>, listLength: number = 0) => {
    const url = `${baseUrl}/excel/${option}`;
    const params = {
        compCd: filter.compCd || undefined,
        date: filter.baseDate ? formatDate(filter.baseDate) : undefined,
        plcaddressid: filter.plcaddressid ?? undefined,
        listLength: listLength
    };
    return await getData<ResponseDto<string>>(url, { params });
}

// 실시간 데이터 조회 
export const getLatestEQM1010_R01 = async ( date : string ) => {

    const url = `${baseUrl}/latest`;
return await getData<ResponseDto<EQM1010_R01Dto[]>>(url, { params: { date } });
};


